import { render, staticRenderFns } from "./Form18Table.vue?vue&type=template&id=d1acac54"
import script from "./Form18Table.vue?vue&type=script&lang=ts"
export * from "./Form18Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports